"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactiveReactiveListProps = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const useReactiveReactProp_1 = require("./useReactiveReactProp");
const useReactiveReactiveListProps = (options) => {
    const { filterStack } = (0, hooks_1.useFilters)();
    const reactiveReactProp = (0, useReactiveReactProp_1.useReactiveReactProp)();
    const context = (0, hooks_1.useReactifySearchContext)();
    const { includeFields, excludeFields } = context.options;
    const size = react_1.default.useMemo(() => {
        var _a, _b;
        return (_b = (_a = options.pageSize) !== null && _a !== void 0 ? _a : filterStack === null || filterStack === void 0 ? void 0 : filterStack.pageSize) !== null && _b !== void 0 ? _b : 20;
    }, [options.pageSize, filterStack]);
    const reactiveReactiveListProps = react_1.default.useMemo(() => ({
        size,
        URLParams: true,
        showLoader: false,
        dataField: "title",
        showResultStats: false,
        react: reactiveReactProp,
        includeFields,
        excludeFields,
        scrollTarget: options.scrollTarget,
        componentId: "page",
        scrollOnChange: false,
        pagination: (filterStack === null || filterStack === void 0 ? void 0 : filterStack.paginationType) !== "infinite_scroll",
        infiniteScroll: (filterStack === null || filterStack === void 0 ? void 0 : filterStack.paginationType) === "infinite_scroll",
        renderNoResults: () => null, // always use only render, otherwise both are shown
    }), [filterStack, reactiveReactProp, options.pageSize]);
    return reactiveReactiveListProps;
};
exports.useReactiveReactiveListProps = useReactiveReactiveListProps;
//# sourceMappingURL=useReactiveReactiveListProps.js.map